const comparePageConfig = {
  maxCars: 3,
  title: "Compare Cars",
  subtitle: "Compare up to {max} cars side by side and pick the best deal",
  empty: {
    title: "No cars to compare",
    message: "Add cars using the Compare button on any listing",
    browseLabel: "Browse Cars",
    browsePath: "/cars",
  },
  bar: {
    label: "{count} car(s) selected",
    compareLabel: "Compare Now",
    clearLabel: "Clear All",
    maxMessage: "You can compare up to {max} cars only",
  },
  toast: {
    addedToCompare: "Added to compare",
    removedFromCompare: "Removed from compare",
    addedToWishlist: "Saved to wishlist",
    removedFromWishlist: "Removed from wishlist",
    compareFull: "Compare list is full ({max} cars max)",
    loginForWishlist: "Log in to save cars to your wishlist",
  },
  cardActions: {
    wishlistAdd: "Save",
    wishlistRemove: "Saved",
    compareAdd: "Compare",
    compareRemove: "In Compare",
  },
  detailActions: {
    wishlistAdd: "Save Car",
    wishlistRemove: "Saved",
    compareAdd: "Add to Compare",
    compareRemove: "Added to Compare",
  },
  specRows: [
    { key: "image", label: "Photo", type: "image" },
    { key: "title", label: "Car", type: "title" },
    { key: "price", label: "Price", type: "currency" },
    { key: "year", label: "Year", type: "text" },
    { key: "km_driven", label: "KM Driven", type: "km" },
    { key: "fuel_type_id", label: "Fuel", type: "lookup", lookup: "fuel_type" },
    { key: "transmission_id", label: "Transmission", type: "lookup", lookup: "transmission" },
    { key: "body_type_id", label: "Body Type", type: "lookup", lookup: "body_type" },
    { key: "seats_id", label: "Seats", type: "lookup", lookup: "seats" },
    { key: "color_id", label: "Color", type: "lookup", lookup: "car_color" },
    { key: "tire_wear", label: "Tyre Wear", type: "percent" },
    { key: "location", label: "Location", type: "text" },
  ],
  actions: {
    removeLabel: "Remove",
    viewDetailsLabel: "View Details",
    addMoreLabel: "Browse More Cars",
    addMorePath: "/cars",
  },
};

export default comparePageConfig;
